<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon clickable" @click="close()">
          <md-icon>arrow_back</md-icon>
        </div>
        <h4>Thông tin chi tiết</h4>
      </md-card-header>
      <md-card-content>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submit)" class="md-layout">
            <div
              class="
                md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100
              "
            >
              <md-field>
                <label>Loại tin</label>
                <md-select v-model="form.type" required>
                  <md-option value="Khuyến mại">Khuyến mại</md-option>
                  <!-- <md-option value="Quảng cáo">Panel quảng cáo</md-option> -->
                  <md-option value="Tin tức">Tin tức</md-option>
                </md-select>
              </md-field>
            </div>

            <div
              class="
                md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100
              "
            >
              <md-field>
                <label>Link đính kèm</label>
                <md-input v-model="form.url"></md-input>
              </md-field>
            </div>

            <div
              class="
                md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100
              "
            >
              <!-- <md-datepicker v-model="form.startDate" :md-immediately="true">
                <label>Ngày Bắt đầu</label>
              </md-datepicker> -->
              <span>Thời điểm bắt đầu</span>
              <DateTimePicker
                class="custom_input"
                v-model="form.startDate"
                :valueFormatted="formattedDate(form.startDate)"
              >
              </DateTimePicker>
            </div>

            <div
              v-show="form.type != 'Tin tức'"
              class="
                md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100
              "
            >
              <!-- <md-datepicker v-model="form.endDate" :md-immediately="true">
                <label>Ngày hết hạn</label>
              </md-datepicker> -->
              <span>Thời điểm kết thúc</span>
              <DateTimePicker
                class="custom_input"
                v-model="form.endDate"
                :valueFormatted="formattedDate(form.endDate)"
              >
              </DateTimePicker>
            </div>

            <div
              class="
                md-layout-item md-size-50 md-small-size-50 md-xsmall-size-100
              "
            >
              <md-field>
                <label>Tiêu đề</label>
                <md-input v-model="form.title" required></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Nội dung</label>
                <md-textarea
                  v-model="form.content"
                  required
                  :md-autogrow="true"
                ></md-textarea>
                <md-icon>description</md-icon>
              </md-field>
            </div>

            <div class="md-layout-item md-size-100">
              <h5>
                <md-icon>collections</md-icon>
                Hình ảnh
              </h5>
              <div class="box-addimage">
                <md-button
                  class="md-fab md-mini md-success md-just-icon md-round"
                  @click="referToInputPickFile"
                >
                  <md-icon>add</md-icon>
                </md-button>
                <div class="md-layout md-alignment-bottom-left">
                  <div
                    :key="index"
                    v-for="(items, index) in form.picture"
                    class="md-xsmall-size-33 container"
                  >
                    <img
                      :src="items.url"
                      style="height: 10vh; width: auto"
                      class="image"
                    />
                    <div class="middle clickable" @click="removeImg(items)">
                      <div class="text"><i class="fas fa-trash-alt"></i></div>
                    </div>
                  </div>
                  <div
                    class="md-layout-item md-size-33"
                    v-show="progress !== 100"
                  >
                    <center>
                      <p class="card-title">
                        {{ Math.floor(progress) + " %" }}
                      </p>
                    </center>
                    <md-progress-bar
                      class="md-primary"
                      :md-value="progress"
                    ></md-progress-bar>
                  </div>
                </div>
                <input
                  id="iconImage"
                  @change="addImg"
                  type="file"
                  accept="image/png, image/jpeg"
                  ref="inputFile"
                  style="display: none"
                />
              </div>
            </div>
            <div
              v-show="form.type != 'Tin tức'"
              class="md-layout-item md-size-100"
            >
              <h5>
                <md-icon>inventory_2</md-icon>
                Sản phẩm
              </h5>
              <div
                class="box-addimage md-size-100 md-layout md-alignment-top-left"
              >
                <md-button
                  class="md-fab md-mini md-success md-just-icon md-round"
                  @click="addProducts"
                >
                  <md-icon>add</md-icon>
                </md-button>
                <div
                  :key="index"
                  v-for="(items, index) in form.listProduct"
                  class="md-xsmall-size-33 md-layout-item md-size-15 container"
                  style="text-align: center"
                >
                  <div class="image">
                    <img
                      :src="
                        items.picture.thumbnail
                          ? items.picture.thumbnail
                          : items.picture.url
                      "
                      style="height: 10vh; width: auto"
                    />
                    <p>{{ items.name }}</p>
                  </div>
                  <div class="middle clickable" @click="removeProducts(index)">
                    <div class="text"><i class="fas fa-trash-alt"></i></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-show="form.type != 'Tin tức'"
              class="md-layout-item md-size-100"
            >
              <h5>
                <md-icon>account_circle</md-icon>
                Nhân viên
              </h5>
              <md-content class="box-addimage md-scrollbar tableEmployee">
                <md-button
                  class="md-fab md-mini md-success md-just-icon md-round"
                  @click="addEmployee"
                  style="margin: 5px"
                >
                  <md-icon>add</md-icon>
                </md-button>
                <md-table
                  :value="listEmployeeSelecteds"
                  :key="isAddEmployee"
                  class="table-hover"
                  table-header-color="green"
                  style="width: 100%"
                >
                  <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item, index }"
                  >
                    <md-table-cell
                      md-label="STT"
                      class="table-cell"
                      align="center"
                    >
                      {{ index + 1 }}</md-table-cell
                    >
                    <md-table-cell
                      md-label="Mã nhân viên"
                      class="table-cell"
                      align="left"
                    >
                      {{ item.employeeCode }}</md-table-cell
                    >
                    <md-table-cell
                      md-label="Tên nhân viên"
                      class="table-cell"
                      align="left"
                    >
                      {{ item.name }}</md-table-cell
                    >
                    <md-table-cell
                      md-label="Email"
                      class="table-cell"
                      align="left"
                    >
                      {{ item.email }}</md-table-cell
                    >
                    <md-table-cell
                      md-label="Số điện thoại"
                      class="table-cell"
                      align="left"
                    >
                      {{ item.phone }}</md-table-cell
                    >
                    <md-table-cell
                      md-label="Vai trò"
                      class="table-cell"
                      align="left"
                    >
                      {{ item.permission }}</md-table-cell
                    >
                    <md-table-cell
                      md-label="Xóa"
                      class="table-cell"
                      align="center"
                    >
                      <md-button
                        class="md-just-icon md-simple md-round md-danger"
                        @click="removeEmployee(item, index)"
                      >
                        <md-icon>delete_forever</md-icon>
                      </md-button>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-content>
            </div>
            <div class="md-layout-item md-size-100">
              <md-button
                :disabled="flagLoading"
                class="md-success"
                type="submit"
                style="margin-right: 10px"
                >{{ itemSelected !== {} ? "Hoàn tất" : "Chỉnh sửa" }}</md-button
              >
              <md-button class="md-danger" @click="close()">hủy</md-button>
            </div>
          </form>
        </ValidationObserver>
      </md-card-content>
    </md-card>
    <modal-add-products
      v-if="isAddProducts"
      :isChangeItem="false"
      :itemChange="''"
      @smallAlertModalHide="smallAlertModalHide"
    ></modal-add-products>
    <add-employee-dialog
      v-if="isAddEmployee"
      :key="isAddEmployee"
      :isAddEmployee="isAddEmployee"
      @closeDialog="isAddEmployee = false"
      @conpleteSelect="conpleteSelect"
      :listEmployee="listEmployee"
      :employeeSelected="form.listEmployee"
    >
    </add-employee-dialog>
  </div>
</template>
<script>
import VueMaterialDateTimePicker from "vue-material-date-time-picker";
import firebase from "@/services/firebase-init.js";
import { mapGetters } from "vuex";
export default {
  components: {
    DateTimePicker: VueMaterialDateTimePicker,
    ModalAddProducts: () => import("../billManagement/ModalAddProducts"),
    AddEmployeeDialog: () => import("./addEmloyeeDialog"),
  },
  computed: {
    ...mapGetters(["flagLoading"]),
  },
  created() {
    this.db = firebase.firestore();
    if (this.itemSelected.data) {
      // console.log("thành công");
      this.form = this.itemSelected.data;
    }
    let bits = localStorage.getItem("bits");
    this.ref = this.db.collection(process.env.VUE_APP_NEWS + bits).doc();
    this.storageRef = firebase.storage().ref("News").child(this.ref.id);
    this.listEmployeeSelecteds = this.listEmployee.filter((item) => {
      return this.form.listEmployee
        ? this.form.listEmployee.includes(item.employeeCode)
        : false;
    });
  },
  props: ["itemSelected", "listEmployee"],
  data() {
    return {
      ref: null,
      storageRef: {},
      db: {},
      form: {
        title: "", // tiêu đề
        content: "", // nội dung
        startDate: new Date(Date.now()), // ngày bắt đầu
        createDate: new Date(Date.now()), // ngày tạo
        endDate: new Date(), // ngày hết hạn
        listProduct: [], // danh sách sản phẩm liên quan
        picture: [], // hình ảnh
        type: "Khuyến mại", // loại tin
        url: "", // link đính kèm
        listEmployee: [],
      },
      listEmployeeSelecteds: [],
      progress: 100,
      isAddProducts: false,
      isAddEmployee: false,
    };
  },
  methods: {
    formattedDate(time) {
      var date = new Date(time);
      var hours = date.getHours().toString().padStart(2, "0");
      var minutes = date.getMinutes().toString().padStart(2, "0");
      var seconds = date.getSeconds().toString().padStart(2, "0");
      var _time = hours + ":" + minutes + ":" + seconds;

      var yyyy = date.getFullYear().toString().padStart(2, "0");
      var month = (date.getMonth() + 1).toString().padStart(2, "0");
      var day = date.getDate().toString().padStart(2, "0");
      var _date = day + "/" + month + "/" + yyyy;

      return _date + " " + _time;
    },
    close() {
      this.$emit("close");
    },
    referToInputPickFile() {
      this.$refs.inputFile.click();
    },
    addImg(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return false;
      } else if (
        files[0].type !== "image/jpeg" &&
        files[0].type !== "image/png" &&
        files[0].type !== "image/jpg"
      ) {
        this.$notify({
          timeout: 3000,
          type: "warning",
          message: "Chỉ cho phép ảnh định dạng jpeg, png hoặc jpg! Thử lại!",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      } else {
        this.uploadImg(files[0]);
      }
    },
    async uploadImg(file) {
      var fileReader = new FileReader();
      var _this = this;
      fileReader.onload = function (event) {
        var imagesRef = _this.storageRef.child(file.name);
        imagesRef
          .getDownloadURL()
          .then((url) => {
            _this.$messageError(
              "Ảnh đã tồn tại trên hệ thống. Đổi tên ảnh rồi thử lại"
            );
          })
          .catch((error) => {
            imagesRef.put(file).on(
              "state_changed",
              (snapshot) => {
                var progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                _this.progress = progress;
              },
              (error) => {
                console.log(error);
              },
              () => {
                _this.$messageSuccess("Tải ảnh lên thành công");
                imagesRef.getDownloadURL().then((downloadURL) => {
                  _this.form.picture.push({
                    ref: file.name,
                    url: downloadURL,
                  });
                });
              }
            );
          });
      };
      fileReader.readAsDataURL(file);
    },
    removeImg(item) {
      var desertRef = this.storageRef.child(item.ref);
      desertRef
        .delete()
        .then(() => {
          this.$messageSuccess("Đã xóa ảnh khỏi cơ sở dữ liệu");
        })
        .catch((error) => {
          console.log(error);
        });
      this.form.picture.splice(this.form.picture.indexOf(item), 1);
    },
    addProducts() {
      this.isAddProducts = true;
    },
    smallAlertModalHide(e) {
      this.isAddProducts = false;
      e.forEach((item) => {
        this.form.listProduct.push({
          productId: item.data.productId,
          name: item.data.name,
          picture: {
            ref: item.data.pictureUrl[0] ? item.data.pictureUrl[0].ref : null,
            url: item.data.pictureUrl[0] ? item.data.pictureUrl[0].url : null,
            thumbnail: item.data.pictureThumbnail,
          },
        });
      });
    },
    removeProducts(index) {
      this.form.listProduct.splice(index, 1);
    },
    addEmployee() {
      this.isAddEmployee = true;
    },
    submit() {
      this.$store.dispatch("FLAG_LOADING", true);
      if (this.itemSelected.data) {
        this.editItem();
      } else {
        this.form.createDate = this.form.createDate.valueOf();
        if (this.form.type == "Tin tức") {
          this.form.startDate = this.form.startDate.valueOf();
          this.ref
            .set({
              title: this.form.title,
              content: this.form.content,
              startDate: this.form.startDate,
              endDate: null,
              createDate: this.form.createDate,
              picture: this.form.picture,
              type: this.form.type,
              url: this.form.url,
            })
            .then((docRef) => {
              this.$messageSuccess("Tạo tin thành công");
              this.$store.dispatch("FLAG_LOADING", false);
              this.close();
            })
            .catch((error) => {
              this.$store.dispatch("FLAG_LOADING", false);
              console.log(error);
            });
        } else {
          this.form.endDate = this.form.endDate.valueOf();
          this.form.startDate = this.form.startDate.valueOf();
          let bits = localStorage.getItem("bits");
          this.ref
            .set(this.form)
            .then((docRef) => {
              this.$messageSuccess("Tạo tin thành công");
              this.$store.dispatch("FLAG_LOADING", false);
              this.close();
            })
            .catch((error) => {
              this.$store.dispatch("FLAG_LOADING", false);
              console.log(error);
            });
        }
      }
    },
    editItem() {
      console.log(this.form.createDate);
      this.form.createDate = this.form.createDate.valueOf();
      this.form.endDate =
        this.form.endDate !== null ? this.form.endDate.valueOf() : null;
      this.form.startDate = this.form.startDate.valueOf();
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_NEWS + bits)
        .doc(this.itemSelected.id)
        .update(this.form)
        .then(() => {
          this.$messageSuccess("Update thông tin thành công");
          this.$store.dispatch("FLAG_LOADING", false);
        })
        .catch((error) => {
          this.$messageError("Lỗi, vui lòng thử lại");
          this.$store.dispatch("FLAG_LOADING", false);
          console.log(error);
        });
    },
    removeEmployee(item, index) {
      this.listEmployeeSelecteds.splice(index, 1);
      this.form.listEmployee = this.listEmployeeSelecteds.map(
        (item) => (item = item.employeeCode)
      );
    },
    conpleteSelect(items) {
      this.listEmployeeSelecteds = this.listEmployee.filter((item) => {
        return items.includes(item.employeeCode);
      });
      this.form.listEmployee = [...items];
      this.isAddEmployee = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.box-addimage {
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 15px;
  border-radius: 5px;
  min-height: 10vh;
  background: #eeeeee;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.123), 0 3px 6px rgba(0, 0, 0, 0.123);
  margin-top: 5px;
}
.icon-remove {
  color: red;
  top: -5px;
  left: -5px;
}
.container {
  position: relative;
}

.image {
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.text {
  background-color: #4caf4f;
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 10px;
}
.container:hover .image {
  opacity: 0.3;
}

.container:hover .middle {
  opacity: 1;
}

.tableEmployee {
  max-height: 30vh;
}

.vmdtp_input {
  border: none !important;
  padding: 0 !important;
}
</style>
